module.exports = __webpack_public_path__ + "media/vo-03-03.c53aff2e.mp3";